import { formatInt } from '@/lib/format';

type Props = {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
};

export function Pagination({ page, pageSize, total, onChange }: Props) {
  const last = Math.max(1, Math.ceil(total / pageSize) || 1);
  return (
    <div className="mt-3 flex items-center gap-2 text-sm">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="inline-flex h-8 items-center rounded-lg border border-nova-border bg-nova-background px-2.5 text-sm text-nova-foreground disabled:cursor-not-allowed disabled:opacity-40"
      >
        Prev
      </button>
      <span className="text-nova-muted-foreground">
        Page {formatInt(page)} / {formatInt(last)} ({formatInt(total)} total)
      </span>
      <button
        type="button"
        disabled={page >= last}
        onClick={() => onChange(page + 1)}
        className="inline-flex h-8 items-center rounded-lg border border-nova-border bg-nova-background px-2.5 text-sm text-nova-foreground disabled:cursor-not-allowed disabled:opacity-40"
      >
        Next
      </button>
    </div>
  );
}
